import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { CircularProgress, Grid, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProbeStates } from "../../../redux/actions/probeStateActions";
import { getServices } from "../../../redux/actions/serviceActions";
import { getReferrals } from "../../../redux/actions/referralActions";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function ProbeDetails({ action, title, open, setOpen, onSubmit }) {
    const dispatch = useDispatch();
    const [id, setId] = useState(null);
    const [createdAt, setCreatedAt] = useState('');
    const [schema, setSchema] = useState('');
    const [data, setData] = useState('');
    const [stateId, setStateId] = useState('');
    const [serviceId, setServiceId] = useState('');
    const [referralId, setReferralId] = useState('');
    const { loading, probes, probe } = useSelector((state) => state.probe);
    const { probeStates } = useSelector((state) => state.probeState);
    const { services } = useSelector((state) => state.service);
    const { referrals } = useSelector((state) => state.referral);
    const emptyState = () => {
        setId(null);
        setCreatedAt('');
        setSchema('');
        setData('');
        setStateId('');
        setServiceId('');
        setReferralId('');
    };
    const handleForm = async (e) => {
        e.preventDefault();
        onSubmit({ id, createdAt, schema, data, stateId, serviceId, referralId });
        setOpen(false);
        emptyState();
    };
    const handleClose = async () => {
        setOpen(false);
        emptyState();
    };
    useEffect(() => {
        const {
            id, createdAt, schema, data, stateId, serviceId, referralId
        } = probe || {};
        setId(id);
        setCreatedAt(createdAt);
        setSchema(schema);
        setData(data);
        setStateId(stateId);
        setServiceId(serviceId);
        setReferralId(referralId);
    }, [probe, probes])
    useEffect(() => {
        let response;
        const getProbeStatesAsync = async () => {
            response = await dispatch(getProbeStates());
        }
        const getServicesAsync = async () => {
            response = await dispatch(getServices());
        }
        const getReferralsAsync = async () => {
            response = await dispatch(getReferrals());
        }
        if (probeStates.length == 0)
        {
            getProbeStatesAsync();
        }
        if (services.length == 0)
        {
            getServicesAsync();
        }
        if (referrals.length == 0)
        {
            getReferralsAsync();
        }
    }, [dispatch, action])
    return (
        <div>
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                {loading ? <CircularProgress/> :
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            {title}
                        </Typography>
                        <Box component="form" onSubmit={handleForm} sx={{mt: 1, display: 'flex', flexWrap: 'wrap'}}>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    Создано: {createdAt}
                                </Grid>
                                <Grid item xs={6}>
                                    Форма: {schema?.jsonSchema}
                                </Grid>
                                <Grid item xs={6}>
                                    Данные: {data?.toString()}
                                </Grid>
                                <Grid item xs={6}>
                                    Статус: {probeStates.find(_ => _.id == stateId)?.name}
                                </Grid>
                                <Grid item xs={6}>
                                    Услуга: {services.find(_ => _.id == serviceId)?.name}
                                </Grid>
                                <Grid item xs={6}>
                                    Направление: {referrals.find(_ => _.id == referralId)?.number}
                                </Grid>
                                {action != 'details' &&
                                    <Grid item xs={6}>
                                        <Button type="submit" fullWidth variant="contained" sx={{mt: 3, mb: 2}}>
                                            {'Сохранить'}
                                        </Button>
                                    </Grid>
                                }
                            </Grid>
                        </Box>
                    </Box>
                }
            </Modal>
        </div>
    )
}
